var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.containsMaximized)?_c('div',{staticClass:"modal-backdrop"}):_vm._e(),_c('div',{staticClass:"video-chat-array d-flex"},_vm._l((_vm.videoCalls),function(call){return _c('MinimizedVideo',{key:call.id,attrs:{"videoChat":call}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }